import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

import { Icon } from 'components';

class Breadcrumbs extends Component {
  static defaultProps = {
    breadcrumbs: [],
  };

  render() {
    const { breadcrumbs } = this.props;

    return (
      <div className="breadcrumbs hide-on-print">
        <div className="wrapper">
          {breadcrumbs.map((breadcrumb, index) => (
            <Fragment key={String(breadcrumb.name)}>
              {breadcrumb.to !== '' && breadcrumb.to !== null ? (
                <Link to={breadcrumb.to} className="breadcrumb-link">
                  {breadcrumb.name}
                </Link>
              ) : (
                <span className="breadcrumb-nolink">{breadcrumb.name}</span>
              )}

              {index + 1 !== breadcrumbs.length && (
                <Icon name="chevron-right" prefix="fa" className="breadcrumb-icon" />
              )}
            </Fragment>
          ))}
        </div>
      </div>
    );
  }
}

export default Breadcrumbs;
